import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function SlideInText({
  children,
  offset = 40,     // parallax intensity (y translation in px)
  duration = 0.8,  // slide-in animation duration
  className = "",
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    // Slide-in animation when entering viewport
    gsap.fromTo(
      el,
      { autoAlpha: 0, y: 40 },
      {
        autoAlpha: 1,
        y: 0,
        duration,
        ease: "power3.out",
     
      }
    );

  }, []);

  return (
    <div
      ref={ref}
      className={`relative will-change-transform ${className}`}
    >
      {children}
    </div>
  );
}
